function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
import React, { useContext } from "react";
import { useUIDSeed } from "react-uid";
import { Section, SectionHeader } from "../../molecules";
import { ImageContext } from "../../../context";
import { Subheading } from "../../atoms";
export var CertificationsGrid = function(param) {
    var label = param.label, title = param.title, callToActions = param.callToActions, certifications = param.certifications, className = param.className, enableLines = param.enableLines;
    var seed = useUIDSeed();
    var ImageComponent = useContext(ImageContext).ImageComponent;
    return /*#__PURE__*/ React.createElement(Section, {
        container: true,
        lines: enableLines ? "dark" : false,
        className: className
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(SectionHeader, {
        variant: "centered",
        label: label,
        labelColor: "secondary",
        title: title,
        callToActions: callToActions
    }), /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-center"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "grid grid-cols-2 gap-9 mt-7 md:mt-10 md:grid-cols-4"
    }, certifications.map(function(cert) {
        return /*#__PURE__*/ React.createElement("div", {
            key: seed(cert)
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex justify-center"
        }, /*#__PURE__*/ React.createElement(ImageComponent, _extends({}, cert.logo, {
            className: "block max-w-[7.5rem] max-h-[7.5rem]"
        }))), !!cert.label && /*#__PURE__*/ React.createElement(Subheading, {
            className: "text-fg-default mt-5 text-center max-w-[8rem]"
        }, cert.label));
    })))));
};

//# sourceMappingURL=CertificationsGrid.js.map